"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/ALFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_8)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_8`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#ED2024"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7 4.88003V11.28L9.84 12.28L7.84 14.24L8.8 15.44L10.92 13.24L11.4 14.16L10.2 16.12L11.64 18.36L10.92 19.4L12.04 20.84L13.12 19.36L12.52 18.32L13.72 16L12.64 14.16L13.12 13.24L15.2 15.44L16.2 14.28L14.12 12.24L17 11.2V4.88003L14.92 5.64003L14.88 7.16003L13.56 7.28003V6.24003L14.24 5.32003L16.48 4.44003L15.56 4.28003L16.12 3.80003L16.48 3.96003L16.16 3.40003L15.6 3.60003L15.2 3.16003L13 3.60003L13.56 4.04003L12.04 6.00003L10.52 4.08003L11.04 3.64003L9.04 3.16003L8.48 3.60003L7.88 3.44003L7.56 4.00003L7.92 3.76003L8.56 4.20003L7.64 4.40003L9.84 5.20003L10.48 6.12003V7.28003L9.16 7.16003V5.72003L7 4.88003Z",
					fill: "#212121"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.47998 9.99996H7.03998V11H4.47998V9.99996ZM4.47998 8.35996H7.03998V9.43996H4.47998V8.35996ZM4.47998 6.67996H7.03998V7.71996H4.47998V6.67996ZM4.47998 5.07996H7.03998V6.07996H4.47998V5.07996Z",
					fill: "#212121"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.96 9.99996H19.52V11H16.96V9.99996ZM16.96 8.35996H19.52V9.43996H16.96V8.35996ZM16.96 6.67996H19.52V7.71996H16.96V6.67996ZM16.96 5.07996H19.52V6.07996H16.96V5.07996Z",
					fill: "#212121"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.36 14.4399H17.92V15.1999H15.36V14.4399ZM6.07999 14.4399H8.63999V15.1999H6.07999V14.4399Z",
					fill: "#212121"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_8`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as ALFlag };
